import React from 'react';
import IcSucessoVerde from '../../../assets/img/ic_sucessoVerde.svg';
import IcErroVermelho from '../../../assets/img/ic_erroVermelho.svg';
import './mensagemModal.css';

interface MensagemModalProps {
    mensagem: string,
    erro?: boolean,
    aviso?: boolean
}

const MensagemModal = (props: MensagemModalProps) =>
{
    const { mensagem, erro, aviso } = props;

    return (
        <div className="container-mensagem">
            {!erro && <img className="icone-mensagem" src={IcSucessoVerde} alt="Icone de sucesso" />}
            {erro && <img className="icone-mensagem" src={IcErroVermelho} alt="Icone de erro" />}
            <span className={aviso ? 'mensagem-retorno mensagem-aviso' : 'mensagem-retorno'}>{mensagem}</span>
        </div>
    );
}

export default MensagemModal;
